import styled from 'styled-components';
import { InlineButton, Text, theme } from '@frameio/vapor';
import TEXT from './generated/TEXT/ProjectList';
import { ProjectItem } from './ProjectItem';

type ProjectListProps = {
  projectIds: string[];
  loading: boolean;
  fetchMore: () => void;
  moreButtonEnabled?: boolean;
  showMoreLabel?: string;
};

export const ProjectList = ({
  projectIds,
  loading,
  fetchMore,
  moreButtonEnabled = false,
  showMoreLabel = 'Show More',
}: ProjectListProps) => {
  const isEmpty = !loading && projectIds.length === 0;

  return (
    <ProjectsListContainer>
      {!loading &&
        projectIds.map((projectId) => (
          <ProjectItem key={projectId} projectId={projectId} />
        ))}

      {moreButtonEnabled && (
        <ShowMoreButton onClick={fetchMore} size="small" variant="primary">
          {showMoreLabel}
        </ShowMoreButton>
      )}

      {!loading && isEmpty && (
        <NoProjects>
          <Text color="secondary" variant="caption">
            {TEXT.noProjects}
          </Text>
        </NoProjects>
      )}
    </ProjectsListContainer>
  );
};

const ProjectsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces[2]};
  & > * {
    padding-left: ${theme.spaces[40]} !important;
  }
`;

const ShowMoreButton = styled(InlineButton)`
  color: ${theme.colors.text.tertiary};
  justify-content: flex-start;

  &:hover {
    color: ${theme.colors.text.primary};
  }
  padding: ${theme.spaces[4]} ${theme.spaces[8]};
`;

const NoProjects = styled.div`
  border-radius: ${theme.radii[6]};
  padding: ${theme.spaces[8]} ${theme.spaces[40]} ${theme.spaces[8]} 0;
`;

TEXT.DEFINE({
  /** Button text to show more projects */
  showMore: 'Show More',
  /** Empty state text when workspace has no projects */
  noProjects: 'No projects',
});
